import React, { useState } from 'react';
import Modal from './Modal';
import { BiPlus } from 'react-icons/bi';
import PatientMedicineServiceModal from './PatientMedicineServiceModal';
import { Button, Input } from '../Form';

function AddProductModal({ closeModal, isOpen }) {
  const [isPatientMedicineModalOpen, setPatientMedicineModalOpen] = useState(false);
  const [selectedItemName, setSelectedItemName] = useState('');
  const [steps, setSteps] = useState([]);
  const [stepInput, setStepInput] = useState('');

  const handleOpenPatientMedicineModal = () => {
    setPatientMedicineModalOpen(true);
  };

  const handleClosePatientMedicineModal = () => {
    setPatientMedicineModalOpen(false);
  };

  const handleSelectItem = (itemName) => {
    setSelectedItemName(itemName);
    handleClosePatientMedicineModal();
  };

  const handleAddStep = () => {
    if (stepInput.trim() !== '') {
      setSteps([...steps, stepInput.trim()]);
      setStepInput('');
    }
  };

  const handleRemoveStep = (index) => {
    const updatedSteps = [...steps];
    updatedSteps.splice(index, 1);
    setSteps(updatedSteps);
  };

  const handleAddButtonClick = () => {
    // Pass selectedItemName and steps to another screen or component here
    console.log("Selected Item Name:", selectedItemName);
    console.log("Steps:", steps);
    // Perform other actions as needed
    closeModal(selectedItemName, steps); // Close modal after handling the data
  };

  return (
    <Modal
      closeModal={closeModal}
      isOpen={isOpen}
      title={selectedItemName !== '' ? selectedItemName : 'Add Item'}
      width={'max-w-xl'}
    >
      <div className="flex-colo gap-6">
        {/* title */}
        <div className="flex flex-col gap-4 w-full">
          <p className="text-black text-sm">Service</p>
          <button
            onClick={handleOpenPatientMedicineModal}
            className=" text-subMain flex-rows gap-2 rounded-lg border border-subMain border-dashed py-4 w-full text-sm"
          >
            <BiPlus /> Add Item
          </button>
          <Input
            label="Product Name"
            color={true}
            placeholder="Crown, FMC"
            value={selectedItemName}
            onChange={(e) => setSelectedItemName(e.target.value)}
          />
        </div>
        {/* Render PatientMedicineServiceModal conditionally */}
        {isPatientMedicineModalOpen && (
          <PatientMedicineServiceModal
            closeModal={handleClosePatientMedicineModal}
            isOpen={true}
            patient={false}
            onSelectItem={handleSelectItem}
          />
        )}
        {/* Steps */}
        { selectedItemName !== "" &&
          <div className="flex flex-col gap-4 w-full">
            <p className="text-black text-sm">Add Steps</p>
            <div className="flex flex-col gap-2">
              {steps.map((step, index) => (
                <div key={index} className="flex flex-row justify-between items-center">
                  <p className="text-xs text-textGray">Step {index + 1}: {step}</p>
                  <button
                    onClick={() => handleRemoveStep(index)}
                    className="text-red-500 text-xs"
                  >
                    Remove
                  </button>
                </div>
              ))}
            </div>
            <div className="flex flex-row items-center gap-2">
              <Input
                value={stepInput}
                color={"#000"}
                onChange={(e) => setStepInput(e.target.value)}
                placeholder="Enter step"
                className="w-full"
              />
              <Button onClick={handleAddStep} label="Add Step" />
            </div>
          </div>
        }
        {/* button */}
        <Button onClick={handleAddButtonClick} label="Add" Icon={BiPlus} />
      </div>
    </Modal>
  );
}

export default AddProductModal;
